export enum OrderStatus {
  ORDER_STATUS_CANCELLED = `106`,
  ORDER_STATUS_COMPLETED = `105`,
  ORDER_STATUS_CONFIRMED = `102`,
  ORDER_STATUS_DELIVERING = `103`,
  ORDER_STATUS_ON_HOLD = `104`,
  ORDER_STATUS_TO_BE_CONFIRMED = `101`,
  ORDER_STATUS_NEW = `100`,
  ORDER_STATUS_NONE = `0`,
}
